export default "__VITE_ASSET__447138ff__"